import { createContext } from 'react';

export const AppProviderThemingEnabledContext: import('react').Context<boolean> =
	createContext(false);
